import { render, staticRenderFns } from "./BM.vue?vue&type=template&id=48d12a0d"
import script from "./BM.vue?vue&type=script&lang=js"
export * from "./BM.vue?vue&type=script&lang=js"
import style0 from "./BM.vue?vue&type=style&index=0&id=48d12a0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports